<script>
    import { appManager } from "../AppManagerStore";
    import { _ } from "svelte-i18n";
</script>

<section id="explainer" class="py-5 py-lg-10">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-10 text-center">
                <span class="badge rounded-pill bg-primary-soft mb-3">
                    <span class="h6 text-uppercase">{$_("communicate.explainer.tag")}</span>
                </span>

                <h1 class="fw-bold">
                    {$_("communicate.explainer.title")}
                </h1>

                <p class="fs-lg text-muted mb-7">
                    {$_("communicate.explainer.subtitle")}
                </p>
            </div>
        </div>
        <div class="row px-md-10">
            <div class="col-12 col-md-6">
                <div class="row">
                    <div class="col-auto col-md-12">
                        <div class="row gx-0 align-items-center mb-md-5">
                            <div class="col-auto">
                                <a
                                    class="btn btn-sm btn-rounded-circle btn-dark disabled opacity-1"
                                    href="#!"><span>1</span></a>
                            </div>
                            <div class="col">
                                <hr
                                    class="d-none d-md-block bg-gray-900-50 me-n7" />
                            </div>
                        </div>
                    </div>
                    <div class="col col-md-12 ms-n5 ms-md-0">
                        <h3 class="text-dark">
                            {$_("communicate.explainer.edit.title")}
                        </h3>
                        <p class="text-muted-80 mb-2">
                            {$_("communicate.explainer.edit.content1")}
                        </p>
                        <p class="text-muted-80 mb-2">
                            {$_("communicate.explainer.edit.content2")}
                        </p>
                        <p class="text-muted-80 mb-2">
                            {$_("communicate.explainer.edit.content3")}
                        </p>
                        <img
                        src="{$appManager.PublicUrl}img/communicate/explainer/after-editor.png"
                            alt="..."
                            class="img-fluid rounded p-2 p-md-5 mb-2 mb-md-4" />
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="row">
                    <div class="col-auto col-md-12">
                        <div class="row gx-0 align-items-center mb-md-5">
                            <div class="col-auto">
                                <a
                                    href="#!"
                                    class="btn btn-sm btn-rounded-circle btn-dark disabled opacity-1"
                                    ><span>2</span></a>
                            </div>
                        </div>
                    </div>
                    <div class="col col-md-12 ms-n5 ms-md-0">
                        <h3 class="text-dark">
                            {$_("communicate.explainer.publish.title")}
                        </h3>
                        <p class="text-muted-80 mb-2">
                            {$_("communicate.explainer.publish.content1")}
                        </p>
                        <p class="text-muted-80 mb-2">
                            {$_("communicate.explainer.publish.content2")}
                        </p>
                        <p class="text-muted-80 mb-2">
                            {$_("communicate.explainer.publish.content3")}
                        </p>
                        <img
                        src="{$appManager.PublicUrl}img/communicate/explainer/after.png"
                            alt="..."
                            class="img-fluid rounded p-2 p-md-5 mb-2 mb-md-4" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .device-screen-scaled {
        height: 166%;
        width: 166%;
    }
    .device-screen-scaled {
        zoom: 0.6;
        -moz-transform: scale(0.6);
        -moz-transform-origin: 0 0;
        -o-transform: scale(0.6);
        -o-transform-origin: 0 0;
        -webkit-transform: scale(0.6);
        -webkit-transform-origin: 0 0;
    }

    @media screen and (-webkit-min-device-pixel-ratio: 0) {
        .device-screen-scaled {
            zoom: 1;
        }
    }
</style>
